export const adminclubUrl = `/adminclub/`;
export const adminclubTaggingTabsUrl = `/adminclub/forum/tagging/:tab(groups|articles)/`;
export const adminclubConceptsHierarchyUrl = `/adminclub/concepts-hierarchy/`;
export const adminclubQuestionOfTheDayUrl = `/adminclub/question-of-the-day/`;
